












import Vue from 'vue';
export default Vue.extend({
  props: {
    route: Object,
  },
  computed: {
    title(): any {
      return this.$route.name;
    },
  },
});
